/**
 * Catálogo de paletas de color del CMDB (eje COLOR).
 *
 * Cada paleta se aplica con el atributo `data-theme` del <html> y solo define
 * colores: fondo, superficies y acento (ver `styles/design-system.css`).
 * La FORMA (radios, sombras, densidad) la aporta el skin — ver `theme/skins.js`.
 *
 * Las claves y los identificadores NO deben cambiar: `cmdb-theme` está guardado
 * en el navegador de los usuarios desde hace tiempo.
 */

export const PALETTES = [
  { id: 'dark',          name: 'Dark',     bg: '#07090f', surface: '#0d0f1a', accent: '#6366f1', base: 'dark'  },
  { id: 'midnight',      name: 'Midnight', bg: '#010a1e', surface: '#071525', accent: '#3b82f6', base: 'dark'  },
  { id: 'ocean',         name: 'Ocean',    bg: '#031318', surface: '#071c22', accent: '#06b6d4', base: 'dark'  },
  { id: 'aurora',        name: 'Aurora',   bg: '#031208', surface: '#071a0e', accent: '#10b981', base: 'dark'  },
  { id: 'dusk',          name: 'Dusk',     bg: '#130810', surface: '#1c0e17', accent: '#ec4899', base: 'dark'  },
  { id: 'sunset',        name: 'Sunset',   bg: '#130a03', surface: '#1a1006', accent: '#f59e0b', base: 'dark'  },
  { id: 'light',         name: 'Light',    bg: '#f1f5f9', surface: '#ffffff', accent: '#6366f1', base: 'light' },
  { id: 'light-sky',     name: 'Sky',      bg: '#f0f5ff', surface: '#ffffff', accent: '#0284c7', base: 'light' },
  { id: 'light-teal',    name: 'Teal',     bg: '#f0fdfa', surface: '#ffffff', accent: '#0d9488', base: 'light' },
  { id: 'light-rose',    name: 'Rose',     bg: '#fff1f2', surface: '#ffffff', accent: '#e11d48', base: 'light' },
  { id: 'light-amber',   name: 'Amber',    bg: '#fffbeb', surface: '#ffffff', accent: '#d97706', base: 'light' },
  { id: 'light-emerald', name: 'Emerald',  bg: '#ecfdf5', surface: '#ffffff', accent: '#059669', base: 'light' },
];

export const DEFAULT_PALETTE = 'dark';

const BY_ID = new Map(PALETTES.map((p) => [p.id, p]));

export function getPalette(id) {
  return BY_ID.get(id) || BY_ID.get(DEFAULT_PALETTE);
}

export function isValidPalette(id) {
  return BY_ID.has(id);
}
